module.exports = __webpack_public_path__ + "img/a.37f68899.jpg";